import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

function Invite() {
	const [searchParams] = useSearchParams();

	// Handle old links where # in the code breaks the URL
	// e.g. /invite?code=#7e6b5b61-...# → searchParams gets empty code, rest goes to hash
	const rawCode = searchParams.get("code");
	const hash = window.location.hash;
	const code = rawCode || (hash ? "#" + hash.replace(/^#/, "") : null);

	useEffect(() => {
		if (!code) return;

		// Try to open the app via deep link
		window.location.href = `gymnote://invite?code=${encodeURIComponent(code)}`;

		// If the app didn't open after 2s, stay on this page
		// (the user can click the store links below)
	}, [code]);

	if (!code) {
		return (
			<div style={containerStyle}>
				<h2 style={titleStyle}>Lien invalide</h2>
				<p style={textStyle}>Ce lien d'invitation n'est pas valide.</p>
			</div>
		);
	}

	return (
		<div style={containerStyle}>
			<h2 style={titleStyle}>Invitation GymNote</h2>
			<p style={textStyle}>
				Quelqu'un vous a invité sur GymNote !
			</p>
			<p style={{ ...textStyle, marginBottom: 30 }}>
				Si l'application ne s'ouvre pas automatiquement, ouvrez GymNote et entrez le code :
			</p>
			<div style={codeStyle}>{code}</div>
			<div style={storeContainer}>
				<a
					href="https://play.google.com/store/apps/details?id=com.frenchmatrix.GymNote"
					style={storeLinkStyle}
				>
					Télécharger sur Google Play
				</a>
			</div>
		</div>
	);
}

const containerStyle = {
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	justifyContent: "center",
	minHeight: "60vh",
	padding: "20px",
	textAlign: "center",
};

const titleStyle = {
	color: "#30a49a",
	fontSize: "28px",
	marginBottom: "15px",
};

const textStyle = {
	color: "#ccc",
	fontSize: "16px",
	marginBottom: "10px",
};

const codeStyle = {
	background: "rgba(48, 164, 154, 0.15)",
	border: "2px solid #30a49a",
	borderRadius: "12px",
	padding: "15px 30px",
	fontSize: "24px",
	fontWeight: "bold",
	color: "#30a49a",
	letterSpacing: "4px",
	marginBottom: "30px",
	userSelect: "all",
};

const storeContainer = {
	display: "flex",
	flexDirection: "column",
	gap: "12px",
};

const storeLinkStyle = {
	color: "#fff",
	background: "#30a49a",
	padding: "12px 24px",
	borderRadius: "8px",
	textDecoration: "none",
	fontSize: "16px",
};

export default Invite;
